'use client';

import { c as _c } from "react/compiler-runtime";
import { AppRouterCacheProvider } from '@mui/material-nextjs/v15-appRouter';
import React from 'react';
import BaseAppProvider from '../AppProvider';
import type { AppProviderProps } from '../AppProvider/types';
const AppProviderNextjs = t0 => {
  const $ = _c(6);
  let appProviderProps;
  let children;
  if ($[0] !== t0) {
    ({
      children,
      ...appProviderProps
    } = t0);
    $[0] = t0;
    $[1] = appProviderProps;
    $[2] = children;
  } else {
    appProviderProps = $[1];
    children = $[2];
  }
  let t1;
  if ($[3] !== appProviderProps || $[4] !== children) {
    t1 = <AppRouterCacheProvider><BaseAppProvider {...appProviderProps}>{children}</BaseAppProvider></AppRouterCacheProvider>;
    $[3] = appProviderProps;
    $[4] = children;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
};
export { AppRouterCacheProvider };
export default AppProviderNextjs;
export { AppProviderNextjs };